export default function ScrollableImageModule(element) {
    return;
    gsap.registerPlugin(ScrollToPlugin);

    gsap.to(element, {
        scrollTo: {y: element.scrollHeight - element.clientHeight},
        duration: 20,
        yoyo: true,
        repeat: -1,
    });

    return this;

}
